import { render } from "./UserAccessManagement.vue?vue&type=template&id=41a3b159"
import script from "./js/userAccessManagement.js?vue&type=script&lang=js&external"
export * from "./js/userAccessManagement.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__